import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PopoverContent } from '../../ui/popover';

interface AppBarPopoverListProps {
  title: string;
  headerAction?: ReactNode;
  isLoading: boolean;
  isEmpty: boolean;
  emptyIcon: ReactNode;
  emptyMessage: string;
  children: ReactNode;
}

export function AppBarPopoverList({
  title,
  headerAction,
  isLoading,
  isEmpty,
  emptyIcon,
  emptyMessage,
  children,
}: AppBarPopoverListProps) {
  const { t } = useTranslation('common');

  return (
    <PopoverContent align="end" className="w-80 p-0">
      <div className="flex items-center justify-between border-b px-3 py-2">
        <span className="text-sm font-semibold">{title}</span>
        {headerAction}
      </div>

      <div className="max-h-96 overflow-y-auto">
        {isLoading ? (
          <div className="px-3 py-6 text-center text-sm text-muted-foreground">
            {t('app.loading')}
          </div>
        ) : isEmpty ? (
          <div className="flex flex-col items-center gap-2 px-3 py-8 text-center text-muted-foreground">
            {emptyIcon}
            <span className="text-sm">{emptyMessage}</span>
          </div>
        ) : (
          children
        )}
      </div>
    </PopoverContent>
  );
}
